export default __webpack_public_path__ + "static/media/lsp-logo.3e258248.svg";